import TermsOfServiceModal from "./TermsOfService";

export default TermsOfServiceModal;
